import React from "react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";

export default function TestCalendar() {
  return (
    <div style={{ padding: 20 }}>
      <h2>Test DayPicker v9</h2>

      <DayPicker month={new Date(2025, 10)} />
    </div>
  );
}
